/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDecimalDelimiter;
function getDecimalDelimiter(locale) {
  return 1.1.toLocaleString(locale).replace(/1/g, '') || '.';
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/NumericInput/src/utils/get-decimal-delimiter.js
// module id = 252
// module chunks = 0